/* eslint-disable no-param-reassign */
import {
  State, CurrentState, SelectingState,
} from '../menu-list.slice';

export default function selectAllExisting(state: State): void {
  if (
    state.current === CurrentState.selecting
    && state.selectingState === SelectingState.allAvailable
  ) {
    state.selectingState = SelectingState.allExisting;
  }
}
